import React from 'react';


import backIcon from '../../../../icons/return.svg'

import classes from './BackIconButton.css';


const backIconButton = props => {


    return (
        <div className={classes.ReturnButton} >
            <div className={classes.ReturnButtonHelper}
                onClick={props.clicked}>
                <img 
                    src={backIcon}
                    alt="not found" />
            </div>
        </div>
    )
}

export default backIconButton


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/BackIconButton/BackIconButton.js